import React, { useEffect, useState, useMemo } from "react";
import { getNotifiedList } from "../../../services/apiService";

const NotifiedList = () => {
  const [notifiedList, setNotifiedList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    fetchNotifiedList();
  }, []);

  const fetchNotifiedList = async () => {
    try {
      const res = await getNotifiedList();
      setNotifiedList(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch notified list:", error);
    } finally {
      setLoading(false);
    }
  };

  // 📄 Pagination Logic
  const totalPages = Math.ceil(notifiedList.length / pageSize);

  const paginatedData = useMemo(() => {
    const start = (page - 1) * pageSize;
    return notifiedList.slice(start, start + pageSize);
  }, [notifiedList, page, pageSize]);

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;

  return (
    <div
      style={{
        padding: "20px",
        background: "#fff",
        borderRadius: "10px",
      }}
    >
      <h3
        style={{
          fontSize: "20px",
          fontWeight: "600",
          marginBottom: "15px",
          color: "#222",
        }}
      >
        Notified List
      </h3>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          background: "#fff",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <thead>
          <tr style={{ background: "#f5f7fa" }}>
            <th style={thStyle}>Product ID</th>
            <th style={thStyle}>Product Name</th>
            <th style={thStyle}>Count</th>
          </tr>
        </thead>

        <tbody>
          {paginatedData.length > 0 ? (
            paginatedData.map((item, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                <td style={tdStyle}>{item.productid}</td>
                <td style={{ ...tdStyle, fontWeight: "600" }}>
                  {item.products}
                </td>
                <td style={{ ...tdStyle, fontWeight: "600" }}>
                  {item.count}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* 📄 Pagination Controls */}
      
<div className="pagination-container">


<div>

Items per page:

<select
className="page-select"
value={pageSize}
onChange={(e) => {
setPageSize(Number(e.target.value));
setPage(1);
}}
>

{[5,10,20,50].map((n)=>(
<option key={n} value={n}>
{n}
</option>
))}

</select>

</div>



<div className="page-buttons">

<button
className="page-btn"
disabled={page===1}
onClick={()=>setPage(page-1)}
>
Previous
</button>


<span className="page-count">

{page} / {totalPages || 1}

</span>


<button
className="page-btn"
disabled={page===totalPages || totalPages===0}
onClick={()=>setPage(page+1)}
>
Next
</button>

</div>


</div>
    </div>
  );
};

const thStyle = {
  padding: "12px",
  textAlign: "left",
  fontSize: "14px",
  fontWeight: "600",
  color: "#333",
  borderBottom: "1px solid #ddd",
};

const tdStyle = {
  padding: "12px",
  fontSize: "14px",
  color: "#444",
};

export default NotifiedList;
